import React from "react";
import { useLocation } from "react-router-dom";
import Header from "./shared/Header";
import Footer from "./shared/Footer";
import DashboardSidebar from "./shared/DashboardSidebar";

const Layout = ({ children }) => {
  const location = useLocation();

  // Show DashboardSidebar only for dashboard-related routes
  const isDashboardPage = location.pathname.startsWith("/dashboard");

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100vh" }}>
      {/* Global Header */}
      <Header />

      <div style={{ display: "flex", flex: 1, marginTop: "60px" }}> {/* Adjust margin to account for header height */}
        {/* Sidebar for dashboard pages */}
        {isDashboardPage && (
          <div style={{ width: "250px", flexShrink: 0 }}>
            <DashboardSidebar />
          </div>
        )}

        {/* Main Content */}
        <main
          style={{
            flex: 1,
            padding: "20px",
            overflowY: "auto", // Enable scrolling for main content
            backgroundColor: "#f9f9f9",
          }}
        >
          {children}
        </main>
      </div>

      {/* Global Footer */}
      <Footer />
    </div>
  );
}


export default Layout;
